(ns minorodata.warehouse-usage.events
  (:require
   [minorodata.warehouse-usage.api]
   [re-frame.core :as re-frame]))

(defn init
  [{:keys [db]} [_ params]]
  (let [generation  (inc (get-in db [:warehouse-usage :generation] 0))
        credits-seq (inc (get-in db [:warehouse-usage :warehouse-credits-seq] 0))
        params      (assoc params :generation generation)]
    {:db         (-> db
                     (assoc-in [:warehouse-usage :generation] generation)
                     (assoc-in [:warehouse-usage :warehouse-credits-seq] credits-seq)
                     (assoc-in [:warehouse-usage :service-breakdown-status] :loading)
                     (assoc-in [:warehouse-usage :user-warehouse-usage-status] :loading)
                     (assoc-in [:warehouse-usage :warehouse-credits-status] :loading)
                     (update :warehouse-usage dissoc :service-breakdown :user-warehouse-usage :warehouse-credits))
     :dispatch-n [[:warehouse-usage.api/fetch-service-breakdown params]
                  [:warehouse-usage.api/fetch-user-warehouse-usage params]
                  [:warehouse-usage.api/fetch-warehouse-credits (assoc params :seq credits-seq)]]}))

(re-frame/reg-event-fx
 :warehouse-usage.events/init
 init)

(defn refresh-granularity
  [{:keys [db]} [_ params]]
  (let [generation  (get-in db [:warehouse-usage :generation] 0)
        credits-seq (inc (get-in db [:warehouse-usage :warehouse-credits-seq] 0))
        params      (assoc params :generation generation :seq credits-seq)]
    {:db       (-> db
                   (assoc-in [:warehouse-usage :warehouse-credits-seq] credits-seq)
                   (assoc-in [:warehouse-usage :warehouse-credits-status] :loading))
     :dispatch [:warehouse-usage.api/fetch-warehouse-credits params]}))

(re-frame/reg-event-fx
 :warehouse-usage.events/refresh-granularity
 refresh-granularity)
